import { helpers, required } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";
import { DateTime } from "luxon";
import { AGE_LIMIT } from "~/utils/constants";
import { userDOB } from "~/utils";

const { locale } = await useLocale("validation");

export default {
  identityType: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  documentNumber: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    documentNumberValid: helpers.withMessage(
      () => locale?.value?.document_number ?? validationJson.document_number,
      Validator.documentNumber,
    ),
  },
  documentCity: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    documentCityValid: helpers.withMessage(
      () => locale?.value?.document_city ?? validationJson.document_city,
      Validator.documentCity,
    ),
  },
  documentExpire: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    validDate: helpers.withMessage(
      () => locale?.value?.invalid_date ?? validationJson.invalid_date,
      Validator.validDate
    ),
    minValue: helpers.withMessage(
      () => locale?.value?.document_expire ?? validationJson.document_expire,
      (value: string) => {
        return DateTime.fromFormat(value, "dd/MM/yyyy") >= DateTime.now();
      },
    ),
    maxValue: helpers.withMessage(
      () => locale?.value?.document_expire ?? validationJson.document_expire,
      (value: string) => {
        return (
          DateTime.fromFormat(value, "dd/MM/yyyy") <=
          DateTime.now().plus({ years: 11 })
        );
      },
    ),
  },
  documentRelease: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    validDate: helpers.withMessage(
      () => locale?.value?.invalid_date ?? validationJson.invalid_date,
      Validator.validDate
    ),
    minValue: helpers.withMessage(
      () => locale?.value?.invalid_date ?? validationJson.invalid_date,
      (value: string) => {
        return DateTime.fromFormat(value, "dd/MM/yyyy") >= userDOB();
      },
    ),
    maxValue: helpers.withMessage(
      () => locale?.value?.document_invalid ?? validationJson.document_invalid,
      (value: string) => {
        return DateTime.fromFormat(value, "dd/MM/yyyy") <= DateTime.now();
      },
    ),
  },
};
